type CallbackType = (data: string) => void;

export interface SocketIO {
    on: (event: string, callback: CallbackType) => void;
    off: (event: string, callback: CallbackType) => void;
    io: {
        connect: () => void;
        disconnect: () => void;
    };
    emit: (eventName: string, data: unknown, callback?: (data: unknown) => void) => void;
}

const getSocketIO = (websocket_host: string): Promise<() => SocketIO> =>
    new Promise((resolve) => {
        if (typeof window === 'undefined') {
            return;
        }

        const script = document.createElement('script');
        script.setAttribute('type', 'application/javascript');
        script.addEventListener('load', () => {
            resolve((): SocketIO => {
                //@ts-expect-error
                const socket = io(websocket_host, { transports: ['websocket', 'polling'] });
                return socket;
            });
        });
        script.setAttribute('src', `${websocket_host}/socket.io/socket.io.js`);
        document.head.appendChild(script);
    });

export class SocketIOCache {
    public data: Map<string, Promise<() => SocketIO>>;

    public constructor() {
        this.data = new Map();
    }

    public getByHost = (websocket_host: string): Promise<() => SocketIO> => {
        const item = this.data.get(websocket_host);

        if (item !== undefined) {
            return item;
        }

        const newItem = getSocketIO(websocket_host);
        this.data.set(websocket_host, newItem);
        return newItem;
    };
}
